/**
 * 헤더의 문구를 리턴한다.
 * @param {*} state 
 * @returns {string} 
 */
const subtitle = state => state.subtitle
/**
 * 헤더의 버튼 타입을 리턴한다.
 * @param {*} state 
 * @returns {string} 
 */
const buttonType = state => state.buttonType
/**
 * 이전 버튼 표시여부를 리턴한다.
 * @param {*} state 
 * @returns {boolean} 
 */
const isShowPrevButton = state => state.isShowPrevButton


export default {
  subtitle,
  buttonType,
  isShowPrevButton
}
